export default __webpack_public_path__ + "static/media/prologue-couch.d5deb5a6.png";